"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
var react_1 = __importDefault(require("react"));
// import { Offline } from 'react-detect-offline'; // when includes ts declaration start using
var react_helmet_1 = require("react-helmet");
var classnames_1 = __importDefault(require("classnames"));
require("./Page.scss");
var LoadingIndicator_1 = require("../LoadingIndicator");
var asperaInitializingTitle = react_1.default.createElement("h1", { className: "has-text-centered" },
    "Establishing ",
    react_1.default.createElement("br", null),
    " Blast Connection");
var offlineTitle = react_1.default.createElement("h1", { className: "has-text-centered" },
    "You appear to be offline",
    react_1.default.createElement("br", null),
    "Check your connection");
var Page = function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_helmet_1.Helmet, { title: props.title }),
    react_1.default.createElement("div", { className: "page" },
        react_1.default.createElement("div", { className: classnames_1.default('section', props.className) }, props.children),
        (props.isLoading || (navigator && !navigator.onLine)) &&
            react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, { title: !navigator.onLine ? offlineTitle : props.isAsperaInitializing ? asperaInitializingTitle : undefined })))); };
exports.Page = Page;
